import { CUSTOMER_ROLE_SLUG } from 'config/app.config';
import { getUserAuthToken } from 'helpers/StorageHelper';
import { type PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { customerMainRoutes } from 'routes/customer/CustomerRoutes';
import { userCurrentRoleSlugSelector } from 'store/auth/selectors/authSelectors';
import { useAppSelector } from 'store/hooks';

// import { useAppSelector } from 'store/hooks';
// import { userInfoSelector } from 'store/auth/selectors/authSelectors';
const ProtectedAdminRoute = ({ children }: PropsWithChildren) => {
  // const userInfo = useAppSelector(userInfoSelector);
  const userCurrentRoleSlug = useAppSelector(userCurrentRoleSlugSelector);
  const user = getUserAuthToken();
  if (!user || userCurrentRoleSlug == CUSTOMER_ROLE_SLUG) {
    // not logged in so redirect to login page with the return url
    return <Navigate to={customerMainRoutes.customerHome.path} replace />;
  } else {
    return children;
  }
};
export default ProtectedAdminRoute;
